import './request-error.less';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
	intl: PropTypes.func,
	fetchData: PropTypes.func,
	toggleProgressBar: PropTypes.func,
	close: PropTypes.func
};

const Error = (props) => {
	const shouldShowRefreshBtn = !!props.fetchData;
	// errors thrown in loadable routes dont have our stuff like intl in props
	const intl = props.intl ? props.intl : val => val;

	return (
		<div className="error-page">
			<div className="content-container">
				<div className="error-page__banner" />
				<p className="error-page__title">{intl('Error')}</p>
				<p className="error-page__desc">{intl('Something went wrong')}</p>
				<div className="btn-wrap">
					{ shouldShowRefreshBtn && (
						<button
							onClick={ e => {
								e.preventDefault();
								if (props.toggleProgressBar) {
									props.toggleProgressBar();
								}
								props.fetchData(props);
							} }
							className="ui-btn ui-btn-primary">
							{intl('Try reload')}
						</button>
					) }&nbsp;
					<button
						onClick={ e => {
							e.preventDefault();
							props.close();
						} }
						className="ui-btn ui-btn-secondary">
						{props.intl('Close')}
					</button>
				</div>
			</div>
		</div>
	);
};

Error.propTypes = propTypes;

export default Error;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/errors/request-error.js